import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { MainLayout } from './components/layout/MainLayout';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { FFSCalculatorPage } from './pages/FFSCalculatorPage';
import { IPSPage } from './pages/IPSPage';
import { CladdingAnalysisPage } from './pages/CladdingAnalysisPage';
import { ThermalAnalysisPage } from './pages/ThermalAnalysisPage';
import { PDFParserPage } from './pages/PDFParserPage';
import { CMMSPage } from './pages/CMMSPage';
import { AdminPage } from './pages/AdminPage';
import { SubscriptionPage } from './pages/SubscriptionPage';
import { AccountPage } from './pages/AccountPage';
import { DocumentationPage } from './pages/DocumentationPage';
import { FAQPage } from './pages/FAQPage';
import { useAuthStore } from './stores/auth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
}

function App() {
  return (
    <Router>
      <Toaster position="top-right" richColors />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<LoginPage />} />
        
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        {/* Analysis Tools */}
        <Route
          path="/tools/ffs"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FFSCalculatorPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/tools/ips"
          element={
            <ProtectedRoute>
              <MainLayout>
                <IPSPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/tools/cladding"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CladdingAnalysisPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/tools/thermal"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ThermalAnalysisPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/tools/pdf-parser"
          element={
            <ProtectedRoute>
              <MainLayout>
                <PDFParserPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/cmms"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CMMSPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AdminPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/subscription"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SubscriptionPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AccountPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        
        {/* Documentation */}
        <Route path="/docs" element={<DocumentationPage />} />
        <Route path="/faq" element={<FAQPage />} />
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
